<template>
  <footer class="pageFooter">
    <div class="container">
      <img src="@/assets/images/logo_slsp.svg" alt="Logo SLSP" />

      <div class="desktop">
        <a
          href="https://www.slsp.sk/sk/information-book/spotrebitel?xloseBtn=true&country=sk&lang=sk"
          target="_blank"
          rel="noopener"
        >
          {{ $t('footer.centrumBezpecnosti') }}
        </a>
        <a
          href="https://www.slsp.sk/sk/ludia/bezpecnost/co-robime-pre-vasu-bezpecnost?closeBtn=true&country=sk&lang=sk"
          target="_blank"
          rel="noopener"
        >
          {{ $t('footer.bezpecnostneInfo') }}
        </a>
      </div>

      <div class="mobile">
        <a
          id="footerMobileNav"
          href="javascript: void(0);"
          class="burgerMenu"
          role="button"
          aria-label="Menu"
          aria-haspopup="true"
          :aria-expanded="`${mobileNavOpened}`"
          @click="mobileNavOpened = !mobileNavOpened"
        >
          <svg class="ico" aria-hidden="true">
            <use href="#ico-menu" xlink:href="#ico-menu" />
          </svg>
        </a>

        <div
          v-if="mobileNavOpened"
          class="mobileNav"
          aria-labelledby="footerMobileNav"
        >
          <div class="container">
            <div class="links">
              <a
                href="https://www.slsp.sk/sk/information-book/spotrebitel?xloseBtn=true&country=sk&lang=sk"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.centrumBezpecnosti') }}
              </a>
              <a
                href="https://www.slsp.sk/sk/ludia/bezpecnost/co-robime-pre-vasu-bezpecnost?closeBtn=true&country=sk&lang=sk"
                target="_blank"
                rel="noopener"
              >
                {{ $t('footer.bezpecnostneInfo') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from 'vue';
const mobileNavOpened = ref(false);
</script>

<style lang="scss">
@use '@/assets/scss/colors.scss';
@use '@/assets/scss/variables.scss';
@use '@/assets/scss/mixins.scss';

.pageFooter {
  position: fixed;
  bottom: 0;
  z-index: 50;

  width: 100%;
  height: mixins.calculateRem(variables.$footerHeight);
  box-shadow: 0 0 mixins.calculateRem(2px) rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: flex-start;
  align-items: center;

  background-color: colors.$eg-sky;

  a {
    font-weight: normal;
  }

  .container {
    display: flex;
    align-items: center;

    .desktop {
      @include mixins.max-breakpoint('md') {
        display: none;
      }
    }

    a {
      @include mixins.fontSize(12px);
      @include mixins.lineHeight(24px);
      color: colors.$g-secondary-900;
      text-decoration: none;

      margin-left: mixins.calculateRem(variables.$spacingHeaderContent);

      &:hover {
        text-decoration: underline;
      }

      &.burgerMenu {
        line-height: 0;
      }
    }

    .mobile {
      display: flex;
      align-items: center;

      @include mixins.breakpoint('lg') {
        display: none;
      }

      margin-left: auto;

      svg {
        $svgSize: 24px;
        width: mixins.calculateRem($svgSize);
        height: mixins.calculateRem($svgSize);

        line-height: 0;

        fill: colors.$g-secondary-900;
      }

      .mobileNav {
        background-color: colors.$eg-sky;

        position: absolute;
        width: 100vw;
        $heightSize: 65px;
        min-height: $heightSize;
        top: -$heightSize;
        left: 0;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        a {
          display: block;
          margin-left: 0;
          @include mixins.lineHeight(30px);

          &:first-child {
            padding-top: 5px;
          }
        }

        .links {
          width: 100%;
        }
      }
    }
  }
}
</style>
